import { dashboardTaskSchema } from "@arti/schemas/dashboard";

import type { TaskSnapshot } from "../types";

export function isHydratedTaskSnapshot(value: unknown): value is TaskSnapshot {
  return dashboardTaskSchema.safeParse(value).success;
}
